var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBloodFilled = function SvgBloodFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.05 9.817-3.683-7.109A1.532 1.532 0 0 0 10 1.875c-.575 0-1.1.317-1.367.833L4.95 9.817a5.661 5.661 0 0 0 .183 5.575A5.67 5.67 0 0 0 10 18.125c2 0 3.825-1.025 4.867-2.733a5.661 5.661 0 0 0 .183-5.575ZM10 16.175a3.638 3.638 0 0 1-3.133-1.767 3.618 3.618 0 0 1-.117-3.583.622.622 0 0 1 .842-.267.63.63 0 0 1 .266.842 2.382 2.382 0 0 0 .075 2.358A2.394 2.394 0 0 0 10 14.925a.624.624 0 1 1 0 1.25Z",
    fill: "current"
  })));
};
export default SvgBloodFilled;